module.exports = __webpack_public_path__ + "src/img/artist/artistpage5.svg?82d1ab5a9ce3a16e48b86f67655bae52";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artistpage5.svg
// module id = 123
// module chunks = 0